{
  "version": 1,
  "asset_id": "e918c6b3-da94-4860-8d02-7dcdb1603646",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/e918c6b3-da94-4860-8d02-7dcdb1603646/avcilar-hizli-elektrikci-7-24-dukkan-4.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/e918c6b3-da94-4860-8d02-7dcdb1603646/avcilar-hizli-elektrikci-7-24-dukkan-4.jpg",
  "original_filename": "avcilar-hizli-elektrikci-7-24-dukkan-4.jpg",
  "size": 637303,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T13:23:38Z"
}
